<template>
  <div>
    <b-row style="margin-bottom: 30px">
      <b-col md="5">
        <b-form-select v-model="courseFilter" :options="podiums.list_courses"
          @input="$store.state.selected_live_course = courseFilter" size="sm"></b-form-select>
      </b-col>
      <b-col md="5"></b-col>
      <b-col md="2"><a
          :href="$store.state.base_url + '/live/podiums/download.php?id=' + $store.state.module.id + '&base=' + $store.state.module.base + '&course=' + encodeURIComponent(courseFilter)"
          target="_blank"><b-button class="inline-btn" size="sm" style="width: auto !important"><b-icon
              icon="cloud-download"></b-icon> Exporter en PDF</b-button></a></b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <div class="podium_list_container"
          v-if="podiums.podium && podiums.podium.podium_scratch_h && podiums.podium.podium_scratch_h.length > 0">
          <div class="podium_list_item">
            <h2 class="align_left">
              <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
              {{ $t("podium_homme") }}
            </h2>
            <b-table striped hover responsive :items="podiums.podium.podium_scratch_h" :fields="fields"
              @row-clicked="openFicheCoureur">
              <template #cell(classement_sexe)="row">
                <img v-if="row.item.classement_sexe == 1" src="../../assets/medaille/or.png" class="medaille_podium" />
                <img v-if="row.item.classement_sexe == 2" src="../../assets/medaille/argent.png"
                  class="medaille_podium" />
                <img v-if="row.item.classement_sexe == 3" src="../../assets/medaille/bronze.png"
                  class="medaille_podium" />
                <b>{{ row.item.classement_sexe }}</b></template>
              <template #cell(nom)="row">
                <span v-if="row.item.nom != '' && row.item.prenom != ''">{{ row.item.nom }} {{ row.item.prenom
                }}</span><span v-else></span>
              </template>
              <template #cell(classement_cat)="row"> {{ row.item.classement_cat }}{{ row.item.abbrev_cat }} </template>
              <template #cell(nation)="row">
                <img v-if="row.item.nation != ''" class="flag"
                  :src="'https://sportips.fr/live/img/Flags/' + row.item.nation + '.jpg'" />
              </template>
            </b-table>
          </div>
        </div>

        <div class="podium_list_container" v-if="podiums.podium && podiums.podium.podiums_cat_h">
          <div class="podium_list_item" v-for="(pod, index) in podiums.podium.podiums_cat_h" :key="index">
            <h2 class="align_left">
              <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
              {{ $t("categorie") }} {{ index }} {{ $t("homme") }}
            </h2>
            <b-table striped hover responsive :items="pod" :fields="fields_cat" @row-clicked="openFicheCoureur">
              <template #cell(classement_cat)="row">
                <img v-if="row.index == 0" src="../../assets/medaille/or.png" class="medaille_podium" />
                <img v-if="row.index == 1" src="../../assets/medaille/argent.png" class="medaille_podium" />
                <img v-if="row.index == 2" src="../../assets/medaille/bronze.png" class="medaille_podium" />
                <b>{{ row.index + 1 }}</b></template>
              <template #cell(nom)="row">
                <span v-if="row.item.nom != '' && row.item.prenom != ''">{{ row.item.nom }} {{ row.item.prenom
                }}</span><span v-else></span>
              </template>
              <template #cell(nation)="row">
                <img v-if="row.item.nation != ''" class="flag"
                  :src="'https://sportips.fr/live/img/Flags/' + row.item.nation + '.jpg'" />
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
      <b-col md="6">
        <div class="podium_list_container"
          v-if="podiums.podium && podiums.podium.podium_scratch_f && podiums.podium.podium_scratch_f.length > 0">
          <div class="podium_list_item">
            <h2 class="align_left">
              <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
              {{ $t("podium_femme") }}
            </h2>
            <b-table striped hover responsive :items="podiums.podium.podium_scratch_f" :fields="fields"
              @row-clicked="openFicheCoureur">
              <template #cell(classement_sexe)="row">
                <img v-if="row.item.classement_sexe == 1" src="../../assets/medaille/or.png" class="medaille_podium" />
                <img v-if="row.item.classement_sexe == 2" src="../../assets/medaille/argent.png"
                  class="medaille_podium" />
                <img v-if="row.item.classement_sexe == 3" src="../../assets/medaille/bronze.png"
                  class="medaille_podium" />
                <b>{{ row.item.classement_sexe }}</b></template>
              <template #cell(nom)="row">
                <span v-if="row.item.nom != '' && row.item.prenom != ''">{{ row.item.nom }} {{ row.item.prenom
                }}</span><span v-else></span></template>
              <template #cell(classement_cat)="row"> {{ row.item.classement_cat }}{{ row.item.abbrev_cat }} </template>
              <template #cell(nation)="row">
                <img v-if="row.item.nation != ''" class="flag"
                  :src="'https://sportips.fr/live/img/Flags/' + row.item.nation + '.jpg'" />
              </template>
            </b-table>
          </div>
        </div>
        <div class="podium_list_container" v-if="podiums.podium && podiums.podium.podiums_cat_f">
          <div class="podium_list_item" v-for="(pod, index) in podiums.podium.podiums_cat_f" :key="index">
            <h2 class="align_left">
              <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
              {{ $t("categorie") }} {{ index }} {{ $t("femme") }}
            </h2>
            <b-table striped hover responsive :items="pod" :fields="fields_cat" @row-clicked="openFicheCoureur">
              <template #cell(classement_cat)="row">
                <img v-if="row.index == 0" src="../../assets/medaille/or.png" class="medaille_podium" />
                <img v-if="row.index == 1" src="../../assets/medaille/argent.png" class="medaille_podium" />
                <img v-if="row.index == 2" src="../../assets/medaille/bronze.png" class="medaille_podium" />
                <b>{{ row.index + 1 }}</b></template>
              <template #cell(nom)="row">
                <span v-if="row.item.nom != '' && row.item.prenom != ''">{{ row.item.nom }} {{ row.item.prenom
                }}</span><span v-else></span>
              </template>
              <template #cell(nation)="row">
                <img v-if="row.item.nation != ''" class="flag"
                  :src="'https://sportips.fr/live/img/Flags/' + row.item.nation + '.jpg'" />
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
      <b-col md="6">
        <div class="podium_list_container"
          v-if="podiums.podium && podiums.podium.podium_scratch_x && podiums.podium.podium_scratch_x.length > 0">
          <div class="podium_list_item">
            <h2 class="align_left">
              <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
              {{ $t("podium_mixte") }}
            </h2>
            <b-table striped hover responsive :items="podiums.podium.podium_scratch_x" :fields="fields"
              @row-clicked="openFicheCoureur">
              <template #cell(classement_sexe)="row">
                <img v-if="row.item.classement_sexe == 1" src="../../assets/medaille/or.png" class="medaille_podium" />
                <img v-if="row.item.classement_sexe == 2" src="../../assets/medaille/argent.png"
                  class="medaille_podium" />
                <img v-if="row.item.classement_sexe == 3" src="../../assets/medaille/bronze.png"
                  class="medaille_podium" />
                <b>{{ row.item.classement_sexe }}</b></template>
              <template #cell(nom)="row">
                <span v-if="row.item.nom != '' && row.item.prenom != ''">{{ row.item.nom }} {{ row.item.prenom
                }}</span><span v-else></span></template>
              <template #cell(classement_cat)="row"> {{ row.item.classement_cat }}{{ row.item.abbrev_cat }} </template>
              <template #cell(nation)="row">
                <img v-if="row.item.nation != ''" class="flag"
                  :src="'https://sportips.fr/live/img/Flags/' + row.item.nation + '.jpg'" />
              </template>
            </b-table>
          </div>
        </div>
        <div class="podium_list_container" v-if="podiums.podium && podiums.podium.podiums_cat_x">
          <div class="podium_list_item" v-for="(pod, index) in podiums.podium.podiums_cat_x" :key="index">
            <h2 class="align_left">
              <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
              {{ $t("categorie") }} {{ index }} {{ $t("mixte") }}
            </h2>
            <b-table striped hover responsive :items="pod" :fields="fields_cat" @row-clicked="openFicheCoureur">
              <template #cell(classement_cat)="row">
                <img v-if="row.index == 0" src="../../assets/medaille/or.png" class="medaille_podium" />
                <img v-if="row.index == 1" src="../../assets/medaille/argent.png" class="medaille_podium" />
                <img v-if="row.index == 2" src="../../assets/medaille/bronze.png" class="medaille_podium" />
                <b>{{ row.index + 1 }}</b></template>
              <template #cell(nom)="row">
                <span v-if="row.item.nom != '' && row.item.prenom != ''">{{ row.item.nom }} {{ row.item.prenom
                }}</span><span v-else></span>
              </template>
              <template #cell(nation)="row">
                <img v-if="row.item.nation != ''" class="flag"
                  :src="'https://sportips.fr/live/img/Flags/' + row.item.nation + '.jpg'" />
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["participants", "courses"],
  data() {
    return {
      courseFilter: "",
      podiums: {},
      possible_podiums: {},
      fields: [
        { key: "classement_sexe", sortable: false, label: this.$t("clt") },
        { key: "nom", sortable: false, label: "Nom" },
        { key: "dossard", sortable: false, label: "Doss." },
        { key: "nation", sortable: false, label: "Nat" },
        { key: "classement", sortable: false, label: "Scratch" },
        { key: "classement_cat", sortable: false, label: "Cat" },
        { key: "temps_arrondi", sortable: false, label: "Temps" },
        { key: "club", sortable: false, label: "Club" },
      ],
      fields_cat: [
        { key: "classement_cat", sortable: false, label: this.$t("clt") },
        { key: "nom", sortable: false, label: "Nom" },
        { key: "dossard", sortable: false, label: "Doss." },
        { key: "nation", sortable: false, label: "Nat" },
        { key: "classement", sortable: false, label: "Scratch" },
        { key: "classement_sexe", sortable: false, label: "Sexe" },
        { key: "temps_arrondi", sortable: false, label: "Temps" },
        { key: "club", sortable: false, label: "Club" },
      ],
    };
  },
  watch: {
    courseFilter() {
      this.fetchPodiums();
    },
  },
  methods: {
    openFicheCoureur(coureur) {
      var fiche_path = "fiche/" + coureur.id;
      this.$router.push({ path: fiche_path });
    },
    buildEndpoint() {
      var url = "/live/podiums/get.php?id=" + this.$store.state.module.id + "&base=" + this.$store.state.module.base;
      if (this.courseFilter != "") {
        url += "&course=" + this.courseFilter;
      }
      if (this.$store.getters['authAdmin/hasAdminRights']) {
        url += "&logged=true";
      }
      return url;
    },

    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.fetchPodiums();
        _this.countdownRefresh();
      }, this.$store.state.refresh_time_live);
      this.$store.state.refreshIntervals.push(intervalObject);
    },
    fetchPodiums() {
      var _this = this;
      var endpoint = this.buildEndpoint();
      axios.get(this.$store.state.base_url + endpoint).then(function (response) {
        console.log("LIVE -- Fetch podiums ");
        _this.podiums = response.data;
        if (_this.courseFilter === "") {
          _this.courseFilter = _this.podiums.list_courses[0];
        }
        if (_this.podiums.podium.timestamp_depart) {
          _this.$store.state.date_selected_course = _this.podiums.podium.timestamp_depart.date_course;
          _this.$store.state.heure_selected_course = _this.podiums.podium.timestamp_depart.heure_depart;
          _this.$store.state.fin_selected_course = _this.podiums.podium.timestamp_depart.course_finie;
        }
      });
    },
  },
  created() {
    this.$store.commit("clearRefreshIntervals");
    if (this.$route.params.course && this.$route.params.course != "") {
      this.courseFilter = this.$route.params.course;
      this.$store.state.selected_live_course = this.courseFilter;
    } else if (this.$store.state.selected_live_course && this.$store.state.selected_live_course != "") {
      this.courseFilter = this.$store.state.selected_live_course;
    }

    this.fetchPodiums();
    this.countdownRefresh();
  },
};
</script>

<style lang="sass" scoped>
</style>